import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="create-outsourced-order"
export default class extends Controller {
  static targets = ["checkbox"];
  connect() {
    console.log("createOutsourcedOrderController connected");
  }

  validateSingleSupplierSelection(event) {
    const checked = this.checkboxTargets.filter((cb) => cb.checked);
    const supplierNames = checked.map(
      (cb) => cb.closest("tr").querySelector("[data-supplier-name]").textContent
    );
    const unique = [...new Set(supplierNames)];
    if (unique.length > 1) {
      alert("異なる仕入先の外注品を一度に選択することはできません。");
      event.target.checked = false;
    }
  }

  async call() {
    if (!confirm("本当に外注書を作成しますか？")) return;
    const checked = this.checkboxTargets.filter((cb) => cb.checked);
    if (checked.length === 0) {
      alert("外注書に追加するアイテムを選択してください。");
      return;
    }

    const form = document.createElement("form");
    form.method = "POST";
    form.action = "/outsourced_order_items/create_outsourced_order";
    form.target = "_blank";

    const csrfInput = document.createElement("input");
    csrfInput.type = "hidden";
    csrfInput.name = "authenticity_token";
    csrfInput.value = document.querySelector("meta[name='csrf-token']").content;
    form.appendChild(csrfInput);

    checked.forEach((cb) => {
      const clone = cb.cloneNode();
      clone.type = "hidden";
      form.appendChild(clone);
    });

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }
}
